import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import LoadingScreen from '../../hoc/LoadingScreen';
import LocationSelect from './LocationSelect/LocationSelect';

const location = (props) => {

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <Form>
            <LocationSelect selectedValue={props.selectedId} locations={props.locations} changed={ (event) => props.locationChanged(event) } />
          </Form>
        </Col>
      </Row>
    </LoadingScreen>
  );

};

export default location;